import { memo } from 'react';
import type { PointerEvent as ReactPointerEvent } from 'react';
import { ResizeAnchor } from '@/enums/dragKind';
import styles from './Note.module.css';

const ANCHOR_CLASS: Record<ResizeAnchor, string> = {
  [ResizeAnchor.TopLeft]: styles.handleTL,
  [ResizeAnchor.Top]: styles.handleT,
  [ResizeAnchor.TopRight]: styles.handleTR,
  [ResizeAnchor.Right]: styles.handleR,
  [ResizeAnchor.BottomRight]: styles.handleBR,
  [ResizeAnchor.Bottom]: styles.handleB,
  [ResizeAnchor.BottomLeft]: styles.handleBL,
  [ResizeAnchor.Left]: styles.handleL,
};

interface Props {
  readonly anchor: ResizeAnchor;
  readonly onPointerDown: (event: ReactPointerEvent<HTMLElement>, anchor: ResizeAnchor) => void;
}

export const ResizeHandle = memo(function ResizeHandle({ anchor, onPointerDown }: Props) {
  return (
    <div
      className={`${styles.handle} ${ANCHOR_CLASS[anchor]}`}
      onPointerDown={(e) => {
        e.stopPropagation();
        onPointerDown(e, anchor);
      }}
      role="separator"
      aria-label={`Resize ${anchor.replace('-', ' ')}`}
      data-anchor={anchor}
    />
  );
});
